import type { AssetMaturity } from '../client/IvtHubClient';

export const MATURITY_SYMBOL: Record<AssetMaturity, string> = {
  EXPLORING: '○',
  BUILDING: '◐',
  PLAYBOOK: '●',
  SCALING: '★',
};

export const MATURITY_COLOR: Record<AssetMaturity, string> = {
  EXPLORING: '#506078',
  BUILDING: '#60a5fa',
  PLAYBOOK: '#10b981',
  SCALING: '#f59e0b',
};

/**
 * Pastel maturity fills used ONLY on the Assets Overview page (Figma re-design):
 * the legend swatches AND the swimlane card backgrounds share this one palette so
 * a card's color matches its legend entry. Scoped to Assets Overview on purpose —
 * MATURITY_COLOR (the vivid accents above) stays the IVT-wide source of truth for
 * NewAssets pages / SolutionMap legend and their pinned tests. Do NOT unify.
 */
export const MATURITY_OVERVIEW_COLOR: Record<AssetMaturity, string> = {
  EXPLORING: '#CCCCAD66', // 探索期
  BUILDING: '#FED53266', // 建设期
  PLAYBOOK: '#FF99004D', // 打法期
  SCALING: '#FA260033', // 规模化
};

export const MATURITY_LABEL: Record<AssetMaturity, string> = {
  EXPLORING: '探索',
  BUILDING: '建设',
  PLAYBOOK: '打法',
  SCALING: '规模化',
};
